import { createFileRoute } from '@tanstack/react-router';

import { BajaRegistryPage } from '@/features/clients/components/client-estado/baja-registry-page';

// /clients/bajas — vista dedicada de clientes dados de baja.
export const Route = createFileRoute('/_app/clients/bajas')({
  component: BajaRegistryPage,
});
